const arraySort = require('array-sort');
const dateUtil = require('../../dateUtil/dateUtil');
const saleCalculator = require('../../domain/sales/saleCalculator');
const constants = require('../../domain/constants');
const storefrontUtility = require('../storefrontUtility');

module.exports.calculateEstimatedHandoverTime = function (sale)
{
    const storefront = storefrontUtility.getStorefrontById(sale.storefrontId);
    const dispatchType = sale.dispatchType;
    const salePrice = saleCalculator.calculateTotalSalePrice(sale);

    let estimatedTime = 45;
    let propertyNow = dateUtil.convertToLocalStandard(dateUtil.getNow());
    let timingConfigurations = storefront.timingConfigurations;

    let timingOverrides = [];
    if (timingConfigurations != null && timingConfigurations.overrides != null)
        timingOverrides = storefront.timingConfigurations.overrides;

    const applicableTimingOverride = this.calculateApplicableTimingOverride(salePrice, dispatchType, propertyNow, timingOverrides);

    const prepTime = applicableTimingOverride != null ? applicableTimingOverride.prepTime : timingConfigurations.defaultPrepTime;
    estimatedTime = (prepTime * 1) || 20;  

    if(dispatchType === constants.DispatchTypeDelivery)
    {
        const deliveryTime = applicableTimingOverride != null ? applicableTimingOverride.deliveryTime : timingConfigurations.defaultDeliveryTime;
        if(deliveryTime)
        {
            estimatedTime += (deliveryTime * 1);
        }
    }
    return estimatedTime;
}

module.exports.calculateApplicableTimingOverride = function (salePrice, dispatchType, localDateTime, overrides)
{
    if (overrides.length === 0) return null;

    const dayOfTheWeek = dateUtil.getDayName(localDateTime);
    const hour = dateUtil.getHours(localDateTime);
    const minute = dateUtil.getMinutes(localDateTime);

    let filtered  = getOverrideByOrderPrice(salePrice, dispatchType, dayOfTheWeek, hour, minute, overrides);
    if(filtered.length !== 0) 
        return arraySort(filtered, 'orderPrice', { reverse: true })[0];

    filtered = getOverrideByDispatchType(dispatchType, dayOfTheWeek, hour, minute, overrides);
    if(filtered.length !== 0) 
        return filtered[0];

    filtered = getOverrideByDayOfTheWeek(dayOfTheWeek, hour, minute, overrides);
    if(filtered.length !== 0) 
        return filtered[0];

    filtered = getOverrideByHourMinute(hour, minute, overrides);
    if(filtered.length !== 0) 
        return filtered[0];

    return null;
}

function getOverrideByOrderPrice(salePrice, dispatchType, dayOfTheWeek, hour, minute, overrides)
{
    overrides = overrides.filter(override => salePrice >= override.orderPrice);
    if (overrides.length === 0) return [];

    const filtered = getOverrideByDispatchType(dispatchType, dayOfTheWeek, hour, minute, overrides);
    return (filtered.length === 0) ? overrides : filtered;
}

function getOverrideByDispatchType(dispatchType, dayOfTheWeek, hour, minute, overrides)
{
    overrides = overrides.filter(override => override.dispatchType === dispatchType);
    if (overrides.length === 0) return [];

    const filtered = getOverrideByDayOfTheWeek(dayOfTheWeek, hour, minute, overrides);
    return (filtered.length === 0) ? overrides : filtered;
}

function getOverrideByDayOfTheWeek(dayOfTheWeek, hour, minute, overrides)
{
    overrides = overrides.filter(override => override.dayOfTheWeek === dayOfTheWeek);
    if (overrides.length === 0) return [];

    const filtered = getOverrideByHourMinute(hour, minute, overrides);
    return (filtered.length === 0) ? overrides : filtered;
}

function getOverrideByHourMinute(hour, minute, overrides)
{    
    let filtered;

    filtered = overrides.filter(override =>
        (override.fromHour <= hour && override.fromMinute <= minute) &&
        (override.toHour >= hour && override.toMinute >= minute));

    return filtered;
}
